import { VStack } from '@musinsa/mwms-ds'
import { getOktaAccessToken } from '@/utils/okta/oktaAuth'
import { AuthStorage } from '@/utils/storage/AuthStorage'
import { clearOktaTokens } from '@/utils/okta/oktaAuth'
import { useNavigate } from 'react-router-dom'
import { PATHS } from '@/utils/routes/paths'

/**
 * LOGISPRD-7099 — Okta 로그인 성공 확인용 dev 랜딩 (REACT_APP_OKTA_DEV_LANDING=true).
 * BE(게이트웨이 Okta 검증 + auth_code self-lookup §7.2) 연동 전까지 메인 진입이 불가하므로,
 * 토큰 교환 성공만 확인한다. BE 준비 후 이 화면/라우트/env 는 제거하고 콜백을 HOME 으로 보낸다.
 */
function OktaDevSuccess() {
	const navigate = useNavigate()
	const token = getOktaAccessToken()

	const backToKnox = () => {
		clearOktaTokens()
		AuthStorage.authMode.clear()
		sessionStorage.setItem('oktaLoginSuspended', '1') // Knox 폼으로 가도 자동 Okta redirect 안 되게
		navigate(PATHS['auth.login'], { replace: true })
	}

	return (
		<VStack block align="center" justify="center" gap={16} style={{ height: '100vh', padding: 24, textAlign: 'center' }}>
			<h2>✅ Okta 로그인 성공 (dev)</h2>
			<div>access token: {token ? `${token.slice(0, 24)}… (${token.length}자)` : '없음'}</div>
			<div style={{ color: '#888', maxWidth: 520 }}>
				SDK 주입 + PKCE 로그인 + 토큰 교환까지 정상. 메인 진입은 BE(게이트웨이 Okta 검증 + auth_code self-lookup)
				연동 후 가능합니다.
			</div>
			<button onClick={backToKnox}>Knox 로그인으로</button>
		</VStack>
	)
}

export default OktaDevSuccess
